var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.icon,{tag:"component",class:['icon', `icon--${_vm.name}`, { [_vm.activeClass]: _vm.isActive }],style:(_vm.iconStyle),attrs:{"width":_vm.width,"height":_vm.size,"role":"presentation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }